import { format, parse } from 'date-fns';

interface Params {
  date: Date | number | string;
  dateFormat?: string;
  inputDateFormat?: string;
  options?: Parameters<typeof format>[2];
}

const getFormattedDate = ({
  date,
  dateFormat = 'dd.MM.y',
  inputDateFormat,
  options
}: Params) => {
  const formatArgs: [string, typeof options] = [
    dateFormat,
    { ...(options || {}) }
  ];

  try {
    return !date
      ? ''
      : typeof date === 'string' && inputDateFormat
      ? format(parse(date, inputDateFormat, Date.now()), ...formatArgs)
      : typeof date === 'string'
      ? format(Date.parse(date), ...formatArgs)
      : format(date, ...formatArgs);
  } catch (err) {
    return '';
  }
};

export default getFormattedDate;
